export default __webpack_public_path__ + "static/sprite-812727801576a1a48be6afa19b7aec20.svg";